<template>
  <div class="modal-content document-margins-modal">
    <div class="modal-header">
      <h5 class="modal-title">Установить отступы</h5>
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="$emit('close')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div
        class="document-margins-modal__body d-flex form-group align-items-center"
      >
        <div>
          <masked-input
            v-model="margin.left"
            class="form-control"
            :options="{
              regex: '[+-]?[0-9]+\\.?([0-9]+)?',
              showMaskOnHover: false,
              showMaskOnFocus: false,
              clearIncomplete: true,
              placeholder: '',
            }"
          ></masked-input>
        </div>
        <div class="ml-5">
          <masked-input
            class="form-control"
            v-model="margin.top"
            :options="{
              regex: '[+-]?[0-9]+\\.?([0-9]+)?',
              showMaskOnHover: false,
              showMaskOnFocus: false,
              clearIncomplete: true,
              placeholder: '',
            }"
          ></masked-input>
          <masked-input
            v-model="margin.bottom"
            class="form-control mt-5"
            :options="{
              regex: '[+-]?[0-9]+\\.?([0-9]+)?',
              showMaskOnHover: false,
              showMaskOnFocus: false,
              clearIncomplete: true,
              placeholder: '',
            }"
          ></masked-input>
        </div>
        <div class="ml-5">
          <masked-input
            v-model="margin.right"
            class="form-control"
            :options="{
              regex: '[+-]?[0-9]+\\.?([0-9]+)?',
              showMaskOnHover: false,
              showMaskOnFocus: false,
              clearIncomplete: true,
              placeholder: '',
            }"
          ></masked-input>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" @click="$emit('close')">
        Закрыть
      </button>
      <button type="button" class="btn btn-primary" @click="setDocumentMargins">
        установить
      </button>
    </div>
  </div>
</template>

<script>
import maskedInput from '../../../components/masked-input.vue'

export default {
  name: 'DocumentMarginsModal',
  components: {
    'masked-input': maskedInput
  },
  props: {
    documentMargins: {
      type: Object,
      default: () => ({
        top: 20,
        right: 10,
        bottom: 20,
        left: 30
      })
    }
  },
  data () {
    return {
      margin: this.documentMargins
    }
  },
  methods: {
    setDocumentMargins () {
      this.$eventBus.$emit('set-document-margins', this.margin)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.document-margins-modal__body {
  min-height: 100px;
}
</style>
